export const CONFIG_STYLES = {
  page: {
    padding: '1.5rem',
    maxWidth: '1200px',
    margin: '0 auto',
  },

  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    gap: '1rem',
    marginBottom: '1.5rem',
  },

  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },

  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '1.5rem',
  },

  formGrid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '1.5rem',
  },

  sectionCard: {
    background: 'var(--sapGroup_ContentBackground)',
    border: '1px solid var(--sapGroup_TitleBorderColor)',
    borderRadius: '0.5rem',
    padding: '1.5rem',
    marginBottom: '1rem',
  },

  infoBox: {
    background: 'var(--sapNeutralBackground)',
    border: '1px solid var(--sapNeutralBorderColor)',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginTop: '1.5rem',
  },

  warningBox: {
    background: 'var(--sapWarningBackground)',
    border: '1px solid var(--sapWarningBorderColor)',
    borderRadius: '0.5rem',
    padding: '1rem',
    marginTop: '1rem',
  },

  infoHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '0.75rem',
  },

  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
  },

  labelHint: {
    color: 'var(--sapContent_LabelColor)',
    fontSize: 'var(--sapFontSmallSize)',
    marginTop: '0.2rem',
  },

  switchRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem 0',
    borderBottom: '1px solid var(--sapGroup_TitleBorderColor)',
  },

  switchRowLast: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0.75rem 0',
  },

  sectionDivider: {
    borderBottom: '1px solid var(--sapGroup_TitleBorderColor)',
    marginBottom: '1.5rem',
    paddingBottom: '0.5rem',
  },
};
